<template>
  <div>
    <div class="modal fade" id="userColorModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Kolor użytkownika: {{ user?.first_name }} {{ user?.last_name }}
            </h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h6>Kolor tła</h6>
            <div class="color-grid mb-4">
              <div v-for="color in backgroundColors" :key="color" class="color-box"
                :class="{ selected: bgcolor === color, disabled: usedBackgrounds.includes(color) }"
                :style="{ backgroundColor: color }" @click="selectBg(color)">
              </div>
            </div>
            <h6>Kolor czcionki</h6>
            <div class="font-grid">
              <div v-for="color in fontColors" :key="color" class="color-box font-box"
                :class="{ selected: font_color === color }" :style="{ backgroundColor: color }" @click="font_color = color">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
              Zamknij
            </button>
            <button type="button" class="btn btn-primary" @click="save">
              Zapisz
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  props: {
    user: Object,
    userColors: {
      type: Array,
      default: () => []
    }
  },

  data() {

    return {
      modalObj: null,
      bgcolor: null,
      font_color: null,
      backgroundColors: [],
      fontColors: [
        '#000000',
        '#333333',
        '#555555',
        '#777777',
        '#ffffff',
        '#ff0000',
        '#0066ff',
        '#008000',
        '#ffa500',
        '#800080'
      ]
    }
  },
  computed: {
    usedBackgrounds() {
      return this.userColors
        .filter(x => x.user_id !== this.user?.id)
        .map(x => x.bgcolor);
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
    this.generateColors();
  },

  methods: {
    show() {
      this.bgcolor = this.user?.kadry_color?.bgcolor ?? null;
      this.font_color = this.user?.kadry_color?.font_color ?? null;
      this.modalObj.show();
    },
    generateColors() {

      let colors = [];

      for (let r = 80; r <= 240; r += 20) {
        for (let g = 80; g <= 240; g += 20) {
          for (let b = 80; b <= 240; b += 20) {

            let hex = '#' +
              r.toString(16).padStart(2, '0') +
              g.toString(16).padStart(2, '0') +
              b.toString(16).padStart(2, '0');

            colors.push(hex);
          }
        }
      }

      this.backgroundColors = colors;

    },

    selectBg(color) {
      if (this.usedBackgrounds.includes(color)) {
        return;
      }
      this.bgcolor = color;
    },

    save() {
      this.$emit(
        'save-color',
        {
          user_id: this.user.id,
          bgcolor: this.bgcolor,
          font_color: this.font_color
        }
      );
      this.hide();
    },

    hide() {
      this.modalObj.hide();
    }
  }
}
</script>
<style scoped>
.color-grid {
  display: grid;
  grid-template-columns: repeat(12, 35px);
  gap: 8px;
  max-height: 280px;
  overflow-y: auto;
}

.font-grid {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.color-box {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  cursor: pointer;
  border: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.color-box:hover {
  border-color: #000;
}

.selected {
  border: 3px solid black !important;
}

.disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

.font-box {
  font-size: 18px;
}
</style>